import React, { Component } from 'react';
import Breadcrumbs from 'react-breadcrumbs';
import glamorous from 'glamorous';
import { FormattedMessage } from 'react-intl';
import { withRouter, hashHistory } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect'
import { Icon, IconClasses } from '@blueprintjs/core';
import { last, get } from 'lodash';
import { getSearchLoadedQuery } from '../selectors';

const CloseButton = ({ loadedSearchQuery }) => (
  <glamorous.A
    className="btn btn-default btn-close"
    css={{ color: '#333 !important' }}
    onClick={e => hashHistory.push({ query: loadedSearchQuery })}
  >
    <Icon
      iconName={IconClasses.SMALL_CROSS}
      iconSize={Icon.SIZE_LARGE}
    />
    <br/>
    <small>
      <FormattedMessage id="common.close"/>
    </small>
  </glamorous.A>
);

const GrBreadcrumbs = (props) => {
  const hasCloseButton = get(last(get(props, 'routes')), 'hasCloseButton', false);
  return (
    <div className="container-fluid container-green notranslate">
      <div className="container">
        <Breadcrumbs
          append={hasCloseButton ? <CloseButton loadedSearchQuery={props.loadedSearchQuery}/> : null}
          wrapperElement="ol"
          itemElement="li"
          wrapperClass="breadcrumb"
          separator="&nbsp;"
          routes={props.routes}
          params={props.params}
        />
      </div>
    </div>
  )
};

const mapStateToProps = createStructuredSelector({
  loadedSearchQuery: getSearchLoadedQuery,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {}),
)(GrBreadcrumbs);



// WEBPACK FOOTER //
// ./src/containers/breadcrumbs.js